'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { GoogleAnalytics } from '@next/third-parties/google';

import { hasCookieConsent } from '@/lib/cookie-consent';

export function useIsStatusPage() {
  const pathname = usePathname();
  return /^\/status/.test(pathname);
}

type ConsentState = boolean | null;

export default function ThirdPartyScripts() {
  const [consent, setConsent] = useState<ConsentState>(null);
  const isStatusPage = useIsStatusPage();

  useEffect(() => {
    try {
      const parsed = hasCookieConsent();
      setConsent(parsed);
    } catch {
      console.log('Issue parsing cookie');
    }
  }, []);

  return (
    <>
      {/* Google Analytics: soft consent */}
      {consent && <GoogleAnalytics gaId="G-SMP87EDCQJ" />}

      {/* Sleekplan: always-on if not a status page */}
      {!isStatusPage && (
        <Script id="sleekplan" strategy="afterInteractive">
          {`
            window.$sleek = [];
            window.SLEEK_PRODUCT_ID = 577902252;
            (function() {
              var d = document;
              var s = d.createElement("script");
              s.src = "https://client.sleekplan.com/sdk/e.js";
              s.async = true;
              d.getElementsByTagName("head")[0].appendChild(s);
            })();
          `}
        </Script>
      )}
    </>
  );
}
